import { useModeAwareQuery } from "./useModeAwareQuery";
import { useApi } from "./useApi";

export interface RiskLevelOption {
  id: number;
  code: string;
  name: string;
  description?: string;
  sortOrder: number;
}

interface RiskLevelApiResponse {
  id: number;
  code: string;
  name: string;
  description?: string;
  sortOrder: number;
}

const mockRiskLevels: RiskLevelOption[] = [
  { id: 1, code: "low", name: "Low", sortOrder: 1 },
  { id: 2, code: "medium", name: "Medium", sortOrder: 2 },
  { id: 3, code: "high", name: "High", sortOrder: 3 },
  { id: 4, code: "critical", name: "Critical", sortOrder: 4 },
];

export function useRiskLevels() {
  const { apiGet } = useApi();

  return useModeAwareQuery<RiskLevelOption[], Error>(
    ["risk-levels"],
    async ({ signal }) => {
      const response = await apiGet<RiskLevelApiResponse[]>("/api/v1/risk-levels", undefined, signal);
      return response.map((x) => ({
        id: x.id,
        code: x.code,
        name: x.name,
        description: x.description,
        sortOrder: x.sortOrder,
      }));
    },
    mockRiskLevels,
    { staleTime: 60 * 1000, refetchOnWindowFocus: false }
  );
}
